/** Trim and return undefined when the value is missing or blank (for `??` fallbacks). */
export function trimmedOrUndefined(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  if (trimmed === undefined || trimmed.length === 0) {
    return undefined;
  }
  return trimmed;
}

/** Remove leading and trailing hyphens in linear time (avoids ReDoS-prone regex). */
function trimEdgeHyphens(value: string): string {
  let start = 0;
  let end = value.length;
  while (start < end && value[start] === '-') {
    start++;
  }
  while (end > start && value[end - 1] === '-') {
    end--;
  }
  return value.slice(start, end);
}

/** DNS-safe tenant subdomain slug (lowercase, hyphenated, 3–63 chars). */
export function slugifyTenantSubdomain(raw: string): string {
  let s = trimEdgeHyphens(
    raw
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-'),
  ).slice(0, 63);
  if (s.length < 3) {
    s = (s + '-app').slice(0, 63);
  }
  return s;
}
